<template>
    <div>
        <v-row>
            <v-col md="12">
                <v-stepper v-model="step" @reload="reloadstep($event)" non-linear>
                    <v-stepper-header>
                        <v-stepper-step :complete="step > 1" step="1" :color="`${buttonColor}`">{{
                            $t("registration.title_step_1") }}</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step v-if="showLoginStep" :complete="step > 2" step="2" :color="`${buttonColor}`">{{
                            $t("registration.title_step_2_optional") }}</v-stepper-step>
                        <v-divider v-if="showLoginStep"></v-divider>
                        <v-stepper-step :complete="step > 2" :step="stepAddress" :color="`${buttonColor}`">{{
                            $t("registration.title_step_3") }}</v-stepper-step>
                        <v-divider v-if="!isSignatoryMode"></v-divider>
                        <v-stepper-step v-if="!isSignatoryMode" :complete="step > 3" :step="stepEmergencyContact" :color="`${buttonColor}`">{{
                            $t("registration.title_step_4") }}</v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-items class="st_items">
                        <v-stepper-content step="1">
                            <v-container>
                                <v-form ref="informationForm" @submit.prevent="goAddressStep">
                                    <v-row>
                                        <v-col cols="12" class="py-1">
                                            <p>{{ $t("registration.subtitle_step_1") }}</p>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field v-model="informationForm.firstname" :rules="rules.firstname"
                                                outlined append-icon="fas fa-user" dense
                                                :label="$t('registration.firstname')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field v-model="informationForm.lastname" :rules="rules.lastname"
                                                append-icon="fas fa-user" outlined dense
                                                :label="$t('registration.lastname')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-menu 
                                                ref="menu" 
                                                v-model="menu" 
                                                :close-on-content-click="false"
                                                :nudge-right="40" 
                                                transition="scale-transition" 
                                                offset-y
                                                min-width="auto"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field 
                                                        :value="formattedBirthdate"
                                                        :rules="rules.birthdate" 
                                                        :label="$t('registration.birthdate')"
                                                        outlined dense 
                                                        append-icon="far fa-calendar-alt" 
                                                        v-bind="attrs"
                                                        v-on="on" 
                                                        readonly
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker 
                                                    :max="max_date" 
                                                    :min="min_date" 
                                                    ref="picker"
                                                    v-model="informationForm.birthdate" 
                                                    @input="menu = false"
                                                    :active-picker.sync="activePicker"
                                                    :header-date-format="$datePicker.formatDateHeader"
                                                    :title-date-format="$datePicker.formatTitleDate"
                                                    :weekday-format="$datePicker.formatWeekday"
                                                    :month-format="$datePicker.formatMonth"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-select 
                                                v-model="informationForm.gender" 
                                                item-value="id" 
                                                item-text="value"
                                                :items="genderItems" 
                                                :rules="rules.gender" 
                                                outlined dense
                                                append-icon="fas fa-venus-mars"
                                                :label="$t('registration.gender')"
                                                :no-data-text="$t('common.no_data')"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col md="6" class="text-left">
                                            <v-btn @click="previusBtn" :color="`${buttonColor}`" class="btn_back">{{
                                                $t("registration.back")}}</v-btn>
                                        </v-col>
                                        <v-col md="6" class="text-right">
                                            <v-btn type="submit" :color="`${buttonColor}`" class="btn_back">{{
                                                $t("registration.next")}}</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-stepper-content>
                        <v-stepper-content v-if="showLoginStep" step="2">
                            <v-container>
                                <v-form ref="informationLogin" @submit.prevent="goEmailStep">
                                    <v-row>
                                        <v-col v-if="$route.path != '/SpectatorsCreate' " cols="12"
                                            class="py-1 text-center">
                                            <p>{{ $t("registration.subtitle_step_2_optional_1") }}<br />
                                                {{ $t("registration.subtitle_step_2_optional_2") }}</p>
                                        </v-col>
                                        <v-col v-else cols="12" class="py-1 text-center">
                                            <p>{{ $t("registration.subtitle_step_2_optional_3") }}<br />
                                                {{ $t("registration.subtitle_step_2_optional_4") }}</p>
                                        </v-col>
                                        <v-col cols="12" :md="createMode === 'emit' ? 12 : 6" class="py-1">
                                            <v-row>
                                                <v-col cols="12" class="pb-0">
                                                    <v-text-field type="email" v-model="informationLogin.email"
                                                        :rules="rules.email_login" outlined
                                                        append-icon="fas fa-envelope" dense
                                                        :label="$t('registration.email')"></v-text-field>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-text-field type="email" v-model="informationLogin.confirmEmail"
                                                        :rules="rules.ver_email_login" append-icon="fas fa-check"
                                                        outlined dense
                                                        :label="$t('registration.confirm-email')"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1" v-if="createMode !== 'emit'">
                                            <v-row>
                                                <v-col cols="12" class="pb-0">
                                                    <v-text-field v-model="informationLogin.password" :rules="[
                                                            value => $inputRules({value}, 'strongPassword') || $t('common.strong_password')
                                                        ]" :label="$t('registration.password')" type="password"
                                                        append-icon="fas fa-lock" outlined dense>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-text-field type="password"
                                                        v-model="informationLogin.confirmPassword"
                                                        :rules="rules.ver_password_login" append-icon="fas fa-check"
                                                        outlined dense
                                                        :label="$t('registration.confirm-password')"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col md="6" class="text-left">
                                            <v-btn @click="step=1" :color="`${buttonColor}`" class="btn_back">{{
                                                $t("registration.back") }}</v-btn>
                                        </v-col>
                                        <v-col md="6" class="text-right">
                                            <v-btn type="submit" :color="`${buttonColor}`" class="btn_back">{{
                                                $t("registration.next")}}</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-stepper-content>
                        <v-stepper-content :step="stepAddress">
                            <v-container>
                                <v-form ref="addressForm" @submit.prevent="goEmergencyContact">
                                    <v-row>
                                        <v-col md="12" class="text-right py-1">
                                            <v-checkbox v-model="chk_address" @change="getAddress"
                                                :color="`${buttonColor}`"
                                                :label="$t('registration.copy_address')"></v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="6" class="py-1">
                                            <template v-if="googleApiKey">
                                                <div :class="`map-container ${hasErrorAddress ? 'input-has-error' : ''}`">
                                                    <label class="map-label">
                                                        <span>{{ $t('profile.address') }}</span>
                                                    </label>
                                                    <i class="far fa-id-card map-icon"></i>
                                                    <ParticipantAddressAutocomplete 
                                                        :ref="`addressAutocomplete${1}`" 
                                                        :id="1"
                                                        :placeHolder="addressForm.address" 
                                                        :address="addressForm.address" 
                                                    />
                                                </div>
                                                <div class="map-error-text">{{ msgErrorAddress }}</div>
                                            </template>
                                            <v-text-field v-else 
                                                v-model="addressForm.address" 
                                                :rules="rules.address"
                                                append-icon="far fa-id-card map-icon" 
                                                outlined dense
                                                :label="$t('profile.address')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-select 
                                                :items="countryItems" 
                                                :rules="rules.country"
                                                v-model="addressForm.country" 
                                                append-icon="fas fa-globe-americas"
                                                outlined dense 
                                                :label="$t('registration.country')"
                                                :no-data-text="$t('common.no_data')"
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-select 
                                                :items="stateItems" 
                                                :rules="rules.state"
                                                v-model="addressForm.state" 
                                                append-icon="far fa-flag" 
                                                outlined dense
                                                :label="$t('registration.state')"
                                                :no-data-text="$t('common.no_data')"
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field v-model="addressForm.city" :rules="rules.city"
                                                append-icon="fas fa-city" outlined dense
                                                :label="$t('registration.city')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field v-model="addressForm.zip" :rules="rules.zip"
                                                append-icon="far fa-id-card" outlined dense
                                                :label="$t('registration.zip')"></v-text-field>
                                        </v-col>


                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field v-model="informationForm.phone" :rules="rules.phone"
                                                append-icon="fas fa-phone-alt" outlined dense
                                                :label="$tc('registration.phone')"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col md="6" class="text-left">
                                            <v-btn @click="step=stepAddress - 1" :color="`${buttonColor}`"
                                                class="btn_back">{{ $t("registration.back")}}</v-btn>
                                        </v-col>
                                        <v-col md="6" class="text-right">
                                            <v-btn type="submit" :color="`${buttonColor}`" class="btn_back">{{
                                                isSignatoryMode ? $t("registration.email_signatory") : $t("registration.next")}}</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-stepper-content>
                        <v-stepper-content v-if="!isSignatoryMode" :step="stepEmergencyContact">
                            <v-container>
                                <v-form ref="emergencyForm" @submit.prevent="createPart">
                                    <v-row>
                                        <v-col md="12" class="text-right py-1">
                                            <v-checkbox 
                                                v-model="chk_emergencyContact" 
                                                @change="getEmergencyContact"
                                                :color="`${buttonColor}`"
                                                :label="$t('registration.copy_emergency_contact')"></v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field append-icon="fas fa-user" v-model="emergencyForm.firstname"
                                                :rules="rules.firstname" outlined dense
                                                :label="$t('registration.firstname')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field append-icon="fas fa-user" v-model="emergencyForm.lastname"
                                                :rules="rules.lastname" outlined dense
                                                :label="$t('registration.lastname')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field 
                                                ref="ecPhone"
                                                append-icon="fas fa-phone-alt" 
                                                v-model="emergencyForm.phone"
                                                :rules="rulesPhoneNumber" 
                                                outlined dense
                                                :label="$t('registration.phone')"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field 
                                                ref="ecCell"
                                                append-icon="fas fa-phone-alt" 
                                                v-model="emergencyForm.cell"
                                                :rules="rulesCellNumber" 
                                                outlined dense
                                                :label="$t('registration.cell')"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field 
                                                ref="ecEmail"
                                                append-icon="fas fa-envelope" 
                                                v-model="emergencyForm.email"
                                                :rules="rules.email_emergency" 
                                                outlined dense
                                                :label="$t('registration.email')"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col md="6" class="text-left">
                                            <v-btn @click="step=stepEmergencyContact - 1" :color="`${buttonColor}`"
                                                class="btn_back">{{ $t("registration.back")}}</v-btn>
                                        </v-col>
                                        <v-col md="6" class="text-right">
                                            <v-btn type="submit" :color="`${buttonColor}`" class="btn_back">{{
                                                $t("registration.next") }}</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-col>
        </v-row>
        <Snack :snack="snackbar" :snackMsg="msg_snackbar" :snackCol="color_snackbar" />
    </div>
</template>

<script>
import LocalStorageService from '@/services/LocalStorageService';
import ProfileService from '@/services/ProfileService';
import AuthService from '@/services/AuthService';
import countryregion from "@/assets/data/countryregion.json";
import RelationshipService from '@/services/RelationshipService';
import GeneralService from '@/services/GeneralService';
import ParticipantAddressAutocomplete from "@/components/profile/ParticipantAddressAutocomplete";
import Snack from '@/components/notifications/Snack';

import { mapGetters, mapState } from 'vuex';
import { VRow, VCol, VStepper, VStepperHeader, VStepperStep, VStepperItems, VMenu, VDatePicker, VCheckbox,
         VTextField, VStepperContent, VContainer, VSelect, VBtn, VDivider, VForm } from 'vuetify/lib';

const informationForm = Object.freeze({ firstname: "", lastname: "", phone: "", birthdate: null, gender: "" });
const informationLogin = Object.freeze({ email: "", password: "", confirmEmail: "", confirmPassword: "" });
const addressForm = Object.freeze({ address: "", country: "", state: "", city: "", zip: "" });
const emergencyForm = Object.freeze({ firstname: "", lastname: "", phone: "", cell: "", email: "" });
const patternPhone = /^[0-9-]{10,12}$/;        
const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
    name: "Register",
    components:{
        ParticipantAddressAutocomplete,
        VRow, VCol, VStepper, VStepperHeader, VStepperStep, VStepperItems, VStepperContent, VContainer,
        VTextField, VSelect, VBtn, VDivider, Snack, VForm, VMenu, VDatePicker, VCheckbox
    },
    props: {
        createMode: {
            type: String,
            default: "default"
        },
        prefillEmail: {
            type: String,
            default: ""
        },
        registrationType: {
            type: String,
            default: ""
        },
        minAdultAge: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            step:1,
            buttonColor: "#000",
            snackbar: false,
            msg_snackbar: "",
            color_snackbar: "",
            informationForm: Object.assign({}, informationForm),
            informationLogin: Object.assign({}, informationLogin),
            addressForm: Object.assign({}, addressForm),
            emergencyForm: Object.assign({}, emergencyForm),
            menu: false,
            password: '',
            ver_password: '',
            email: '',
            userId: 0,
            countryItems:[],
            stateItems: [],
            chk_emergencyContact: false,
            profile: null,
            chk_address: false,
            showPass: false,
            showVerPass: false,
            activePicker: null,
            isNotAvailableValidate: false,
            isValidateAddress: false,
            matchedUserEmail: ''
        }
    },
    computed: {
        ...mapGetters({
            addressDataComponentUpdateVersion: 'getAddressDataComponentUpdateVersion',
            addressDataComponentUpdateId: 'getAddressDataComponentUpdateId',
            addressDataComponents: 'getAddressDataComponents'
        }),
        ...mapState({
            googleApiKey: (state) =>state.env.get('VUE_APP_GOOGLE_MAPS_API_KEY')
        }),
        rulesCellNumber() {
            return [
                (val) => (val || "").length > 0 || this.$t("registration.cell_number_required"),
                (val) => {

                        let vm = this, response
                        if((val || "").length > 0)
                           response = !!val.match(/^[0-9-]{10,12}$/)
                        

                        if((val || "").match(/^[0-9-]{3,12}$/)){
                            vm.emergencyForm.cell=vm.emergencyForm.cell.replaceAll("-", "")
                            const lengthPhone = vm.emergencyForm.cell.length
                            
                            if(lengthPhone>=4 && lengthPhone<7){
                                vm.emergencyForm.cell=vm.emergencyForm.cell.substring(0, 3)+"-"+vm.emergencyForm.cell.substring(3)
                                
                            }

                            if(lengthPhone>=7){
                            vm.emergencyForm.cell=vm.emergencyForm.cell.replaceAll("-", "")
                            vm.emergencyForm.cell=vm.emergencyForm.cell.substring(0, 3)+"-"+vm.emergencyForm.cell.substring(3, 6) +"-"+vm.emergencyForm.cell.substring(6)
                            }
                            if(lengthPhone<10){
                                return this.$t("registration.phone_invalid")
                            }else if(lengthPhone>10){
                                return this.$t("registration.phone_invalid")
                            }else{
                                vm.emergencyForm.cell=vm.emergencyForm.cell.replaceAll("-", "")
                                vm.emergencyForm.cell=vm.emergencyForm.cell.substring(0, 3) +"-"+vm.emergencyForm.cell.substring(3, 6) +"-"+vm.emergencyForm.cell.substring(6, 10)
                            } 
                        }
                        if(!response)
                            return this.$t("registration.phone_invalid")

                        return true;
                }
            ];
        },
        rulesPhoneNumber() {
            return [
                (val) => (val || "").length > 0 || this.$t("registration.phone_required"),
                (val) => {

                        let vm = this, response
                        if((val || "").length > 0)
                           response = !!val.match(/^[0-9-]{10,12}$/)
                        

                        if((val || "").match(/^[0-9-]{3,12}$/)){
                            vm.emergencyForm.phone=vm.emergencyForm.phone.replaceAll("-", "")
                            const lengthPhone = vm.emergencyForm.phone.length
                            
                            if(lengthPhone>=4 && lengthPhone<7){
                                vm.emergencyForm.phone=vm.emergencyForm.phone.substring(0, 3)+"-"+vm.emergencyForm.phone.substring(3)
                                
                            }

                            if(lengthPhone>=7){
                            vm.emergencyForm.phone=vm.emergencyForm.phone.replaceAll("-", "")
                            vm.emergencyForm.phone=vm.emergencyForm.phone.substring(0, 3)+"-"+vm.emergencyForm.phone.substring(3, 6) +"-"+vm.emergencyForm.phone.substring(6)
                            }
                            if(lengthPhone<10){
                                return this.$t("registration.phone_invalid")
                            }else if(lengthPhone>10){
                                return this.$t("registration.phone_invalid")
                            }else{
                                vm.emergencyForm.phone=vm.emergencyForm.phone.replaceAll("-", "")
                                vm.emergencyForm.phone=vm.emergencyForm.phone.substring(0, 3) +"-"+vm.emergencyForm.phone.substring(3, 6) +"-"+vm.emergencyForm.phone.substring(6, 10)
                            } 
                        }
                        if(!response)
                            return this.$t("registration.phone_invalid")

                        return true;
                }
            ];
        },
        isSignatoryMode() {
            return this.createMode === 'emit';
        },
        ageValidate18() {
            const arrayDate = (this.informationForm.birthdate || "").toString().split("-");
            if(arrayDate.length > 2) {
                const birthdate = new Date(arrayDate[0], parseInt(arrayDate[1] - 1), arrayDate[2]);
                const _now = new Date();
                const requiredAge = this.minAdultAge > 0 ? this.minAdultAge : 18;
                const agoRequiredAge = new Date(_now.getFullYear() - requiredAge, _now.getMonth(), _now.getDate());
                return birthdate <= agoRequiredAge;
            }
            return false;            
        },
        showLoginStep() {
            return this.ageValidate18 && !this.isSignatoryMode;
        },
        stepAddress() {
            return this.showLoginStep ? 3 : 2;
        },
        stepEmergencyContact() {
            return this.showLoginStep ? 4 : 3;
        },
        formattedBirthdate() {
            if (!this.informationForm.birthdate) return '';
            return this.$options.filters.formatDateForHumans(this.informationForm.birthdate, false);
        },
        max_date() {
            const CURDATE = new Date();
            CURDATE.setDate(CURDATE.getDate() - 1);
            if (this.minAdultAge && this.minAdultAge > 0) {
                CURDATE.setFullYear(CURDATE.getFullYear() - this.minAdultAge);
            }
            const YEAR = CURDATE.getFullYear();
            const MONTH = (CURDATE.getMonth() + 1).toString().padStart(2, '0');
            const DAY = CURDATE.getDate().toString().padStart(2, '0');
            const STRING_DATE = [YEAR, MONTH, DAY].join('-');

            return STRING_DATE;
        },
        min_date() {
            const CURDATE = new Date();
            const YEAR = CURDATE.getFullYear() - 125;
            const MONTH = (CURDATE.getMonth() + 1).toString().padStart(2, '0');
            const DAY = (CURDATE.getDate()).toString().padStart(2, '0');
            const STRING_DATE = [YEAR, MONTH, DAY].join('-');

            return STRING_DATE;
        },
        spaceCleaner() {
            return [
                this.informationLogin.email,
                this.informationLogin.confirmEmail,
                this.informationLogin.password,
                this.informationLogin.confirmPassword
            ];
        },
        rules() {
            return {
                address: [ 
                    val => (val || "").length > 0 || this.$t("registration.address_required"),
                    val => ((val || "").length > 3 && (val || "").length < 100) || this.$t("registration.length_address")
                ],
                country:[
                    val => (val || "").length > 0 || this.$t("registration.country_required")
                ],
                state: [
                    val => (val || "").length > 0 || this.$t("registration.state_required")
                ],
                city:[
                    val => (val || "").length > 0 || this.$t("registration.city_required")
                ],
                zip:[
                    val =>  val === 0 || val === "0" || (val || "").toString().length > 0 || this.$t("registration.zip_required")
                ],
                firstname: [ 
                    val => (val || "").length > 0 || this.$t("registration.firstname_required"),
                    val => ((val || "").length > 1 && (val || "").length < 100) || this.$t("registration.length_firstname")
                ],
                lastname: [ 
                    val => (val || "").length > 0 || this.$t("registration.lastname_required"),
                    val => ((val || "").length > 2 && (val || "").length < 100) || this.$t("registration.length_lastname")
                ],
                email_emergency: [ 
                    (val) => {
                        const cond = (this.emergencyForm.phone || '').length > 0 || (this.emergencyForm.cell || '').length > 0 || (val || '').length > 0 || '';
                        if(cond == '' && !this.isNotAvailableValidate && this.stepEmergencyContact == this.step) {
                            this.showSnackBar(this.$t('registration.phone_cell_email_required'),'error');
                        }
                        return cond;
                    },
                    (val) => this.isValidEmail(val) || this.$t("registration.email_invalid")
                ],
                email: [ 
                    val => {
                        if((val || "").length > 0)
                            return pattern.test(val) || this.$t("registration.email_invalid")

                        return true;
                    }
                ],
                phone:[
                    val => (val || "").length > 0 || this.$t("registration.phone_required"),
                    val => {
                        let vm = this, response
                        if((val || "").length > 0)
                           response = !!val.match(patternPhone) 
                        

                        if((val || "").match(/^[0-9-]{3,12}$/)){
                            vm.informationForm.phone=vm.informationForm.phone.replaceAll("-", "")
                            const lengthPhone = vm.informationForm.phone.length
                            
                            if(lengthPhone>=4 && lengthPhone<7){
                                vm.informationForm.phone=vm.informationForm.phone.substring(0, 3)+"-"+vm.informationForm.phone.substring(3)
                                
                            }

                            if(lengthPhone>=7){
                            vm.informationForm.phone=vm.informationForm.phone.replaceAll("-", "")
                            vm.informationForm.phone=vm.informationForm.phone.substring(0, 3)+"-"+vm.informationForm.phone.substring(3, 6) +"-"+vm.informationForm.phone.substring(6)
                            }
                            if(lengthPhone<10){
                                return this.$t("registration.phone_invalid")
                            }else if(lengthPhone>10){
                                return this.$t("registration.phone_invalid")
                            }else{
                                vm.informationForm.phone=vm.informationForm.phone.replaceAll("-", "")
                                vm.informationForm.phone=vm.informationForm.phone.substring(0, 3) +"-"+vm.informationForm.phone.substring(3, 6) +"-"+vm.informationForm.phone.substring(6, 10)
                            } 
                        }
                        if(!response)
                            return this.$t("registration.phone_invalid")

                        return true;
                    }
                ],
                phone_emergency: [ 
                    val => (val || "").length > 0 || this.$t("registration.email_required"),
                    val => val.match(patternPhone) || this.$t("registration.phone_invalid")
                ],
                gender: [ 
                    val => (val || "").length > 0 || this.$t("registration.gender_required")
                ],
                birthdate: [ 
                    () => (this.informationForm.birthdate || "").length > 0 || this.$t("registration.birthdate_required"),
                    () => {
                        const raw = this.informationForm.birthdate || "";
                        const arrayDate = raw.split("-");
                        const birthdate = new Date(arrayDate[0], parseInt(arrayDate[1] - 1), arrayDate[2]);
                        const _now = new Date();
                        const agoYear1 = new Date(_now.getFullYear(), _now.getMonth() + 1, _now.getDate() -1);
                        return birthdate <= agoYear1 || this.$t("registration.birthdate_invalid")
                    }
                ],
                password: [ 
                    val =>{
                        if(val.length > 0)
                            return ((val || "").length > 3 && (val || "").length < 50) || this.$t("registration.length_password")
                        return true;
                    }
                ],
                ver_password:[
                    val =>{
                        if(this.password == val)
                            return (this.password == val) || this.$t("registration.password_equals")
                        return true;
                    }
                ],
                email_login: [ 
                    val => (val || "").length > 0 || this.$t("registration.email_required"),
                    val => {
                        if((val || "").length > 0) {
                            if(pattern.test(val)){
                                this.informationLogin.email = this.informationLogin.email.toLowerCase();
                                
                            }else{
                                return this.$t("registration.email_invalid")
                            }
                           
                        }
                        return true;
                    }
                ],
                password_login: [ 
                    val => (val || "").length > 0 || this.$t("registration.password_required"),
                    val =>{
                        if((val || "").length > 0)
                            return ((val || "").length > 3 && (val || "").length < 50) || this.$t("registration.length_password")
                        return true;
                    }
                ],
                ver_password_login:[
                    val =>{
                        if((this.informationLogin.password || "").length > 0)
                            return (this.informationLogin.password == val) || this.$t("registration.password_equals")
                        return true;
                    }
                ],
                ver_email_login: [
                    val => {
                        if((val || "").length > 0) {
                            if(pattern.test(val)){
                                this.informationLogin.confirmEmail = this.informationLogin.confirmEmail.toLowerCase();
                                
                            }else{
                                return this.$t("registration.email_invalid")
                            }
                           
                        }
                        if((this.informationLogin.email || "").length > 0)
                            return (this.informationLogin.email == val) || this.$t("registration.email_equals")
                        return true;
                    }
                ]
            };
        },
        genderItems() {
            return [
                {id: '', value: this.$t("registration.select_gender") },
                {id: 'male', value: this.$t("registration.male") },
                {id: 'female', value: this.$t("registration.female")}
            ];
        },
        hasErrorAddress() {
            if(this.isValidateAddress) {
                const { address } = this.addressForm;
                return (address || '').length == 0;
            }
            return false;
        },
        phoneNumber() {
            return this.informationForm.phone;
        },
        emergencyContactPhone() {
            return this.emergencyForm.phone;
        },
        emergencyContactCell() {
            return this.emergencyForm.cell;
        },
        msgErrorAddress() {
            return this.hasErrorAddress ? this.$t('registration.address_required') : '';
        }
    },
    created(){
        this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
        this.getcurrentUser();
        this.loadCountries();
    },
    methods:{
        verifyPass(){
            if(this.password.length > 0 && (this.password != this.ver_password)){
                this.snackbar = true;
                this.msg_snackbar = this.$t("registration.password_equals");
                this.color_snackbar = "error";
                this.$refs['pass2'].focus();
            }
        },
        loadCountries() {
            this.countryItems = countryregion.countries;
            GeneralService.getCountries().then((resp) => {
                this.countryItems = resp.data;
            });
        },
        getStatesByCountry() {
           this.stateItems = countryregion.regions[this.addressForm.country];
           if(this.addressForm.country) {
            GeneralService.getStates(this.addressForm.country).then((resp) => {
               this.stateItems = resp.data;
            });
           } else {
            this.stateItems = []; 
           }
        },
        validateCountryState() {
            if(!this.countryItems.includes(this.addressForm.country)) {
                this.addressForm.country = '';
                this.addressForm.state = '';
            }
            if(this.addressForm.state && !this.stateItems.includes(this.addressForm.state)) {
                this.addressForm.state = '';
            }
        },
        getcurrentUser(){
            AuthService.getUserCurrent().then(response =>{
                if(response.data.success == 1){
                    this.userId = response.data.message.id;
                    let data = {
                        userId: this.userId,
                        authUserId: 0
                    };
                    ProfileService.getProfile(data).then(repons =>{
                        if(repons.data.success == 1){
                            this.profile = repons.data.message;                            
                        }
                    });
                }
            });
        },
        showSnackBar(msg, color){
            if(!this.snackbar) {
                this.snackbar = true;
                setTimeout(() => this.snackbar = false, 6000);
            }
            this.msg_snackbar = msg;
            this.color_snackbar = color;
        },
        async goAddressStep(){
            
            if(!this.$refs.informationForm.validate()) {
                this.showSnackBar(this.$t("registration.validate_step"), "error");
                return
            }
            
            try {
                const response = await AuthService.matchUser({
                    firstname: this.informationForm.firstname,
                    lastname: this.informationForm.lastname,
                    birthday: this.informationForm.birthdate
                });

                if (response && response.data && response.data.success === 1 && response.data.user) {
                    const user = response.data.user;
                    
                    // Autofill data
                    this.informationLogin.email = user.emailAddress || '';
                    if (this.createMode !== 'emit') {
                        this.informationLogin.password = '';
                        this.informationLogin.ver_password = '';
                    }

                    this.informationForm.phone = user.phone || '';
                    
                    this.addressForm.address = user.address || '';
                    this.addressForm.city = user.city || '';
                    this.addressForm.zip = user.zip || '';
                    
                    if (user.country) {
                        this.addressForm.country = user.country;
                        this.getStatesByCountry();
                    }
                    if (user.state) {
                        setTimeout(() => {
                            this.addressForm.state = user.state;
                        }, 500); // Wait for states to load
                    }

                    this.emergencyForm.firstname = user.eContactFirstName || '';
                    this.emergencyForm.lastname = user.eContactLastName || '';
                    this.emergencyForm.phone = user.eContactPhone || '';
                    this.emergencyForm.cell = user.eContactCell || '';
                    this.emergencyForm.email = user.eContactEmail || '';

                    this.matchedUserEmail = user.emailAddress || '';

                    this.showSnackBar(this.$t("registration.user_found_autofilled") || "Found matching user. Data autofilled.", "success");
                    
                    if (this.createMode === 'emit') {
                        this.$emit("created", {
                            idUser: user.id,
                            email: user.emailAddress || this.prefillEmail || "",
                            firstName: user.firstName || this.informationForm.firstname,
                            lastName: user.lastName || this.informationForm.lastname,
                            birthdate: user.birthday || this.informationForm.birthdate
                        });
                        this.clearForm();
                        return;
                    } else {
                        this.createPart(true);
                        return;
                    }
                }
            } catch (error) {
                // Error matching user — non-critical, proceed to step 2
            }

            this.step = 2;
            
        },
        goEmergencyContact(){

            this.validateCountryState();

            if(!this.validatePhone()) return;

            setTimeout(() => {
                if(this.googleApiKey) {
                    this.isValidateAddress = true;
                }

                if(this.hasErrorAddress || !this.$refs.addressForm.validate()) {
                    if(this.hasErrorAddress) this.$refs.addressForm.validate();
                    this.showSnackBar(this.$t("registration.validate_step"), "error");
                    return
                } 

                if (this.isSignatoryMode) {
                    this.createPart(true);
                    return;
                }
                this.step = this.stepAddress + 1;
            },500);
        },
        validatePhone(){

            if(this.informationForm.phone.length==0){
                    this.showSnackBar(this.$t("profile.phone_invalid_empty"), "error");
                    return false;
            }
            if(this.informationForm.phone.match(/^[0-9-]{10,12}$/)){
                    const simbol = this.informationForm.phone.split("-")
                    if(simbol.length>3)
                    {
                        this.showSnackBar(this.$t("profile.phone_invalid"), "error");
                        return false;
                    }else{
                    this.informationForm.phone=this.informationForm.phone.replaceAll("-", "")
                        if(this.informationForm.phone.length<10){
                            this.showSnackBar(this.$t("profile.phone_invalid"), "error");
                            return false;
                        }else if(this.informationForm.phone.length>10){
                            this.showSnackBar(this.$t("profile.phone_invalid"), "error");
                            return false;
                        }else{
                            this.informationForm.phone=this.informationForm.phone.substring(0, 3) +"-"+this.informationForm.phone.substring(3, 6) +"-"+this.informationForm.phone.substring(6, 10)
                            return true;
                        }   
                    }
                    
            }
            
        },
        getEmergencyContact(){
            this.isNotAvailableValidate = true;
            if(this.chk_emergencyContact){
                this.emergencyForm.firstname = this.profile.firstName;
                this.emergencyForm.lastname = this.profile.lastName;
                this.emergencyForm.phone = this.profile.phone;
                this.emergencyForm.cell = this.profile.phone;
                this.emergencyForm.email = this.profile.emailAddress;
            }else{
                this.emergencyForm.firstname = '';
                this.emergencyForm.lastname = '';
                this.emergencyForm.phone = '';
                this.emergencyForm.cell = '';
                this.emergencyForm.email = '';
                this.$refs.emergencyForm.resetValidation();
            }
            setTimeout(() => {
                this.isNotAvailableValidate = false;
            },1000);
        },
        getAddress(){
            let addressObj = {
                country: '',
                address: '',
                city: '',
                state: '',
                zip: ''
            };
            if(this.chk_address){
                addressObj.country = this.profile.country;
                this.getStatesByCountry();
                addressObj.address = this.profile.address;
                addressObj.city = this.profile.city;
                addressObj.state = this.profile.state;                    
                addressObj.zip = this.profile.zip;
            }
            this.addressForm.address = addressObj.address;
            if(this.googleApiKey) {
                if(this.$refs.addressAutocomplete1) {
                    setTimeout(() => { 
                        if(this.$refs.addressAutocomplete1) {
                            this.$refs.addressAutocomplete1.updateAddress();
                        }
                        setTimeout(() => {
                            this.addressForm.country = addressObj.country;
                            this.addressForm.city = addressObj.city;
                            this.addressForm.state = addressObj.state;
                            this.addressForm.zip = addressObj.zip;
                        },20);
                    },200);
                }
                this.informationForm.phone = this.profile.phone;
            } else {
                this.addressForm.country = addressObj.country;
                this.addressForm.city = addressObj.city;
                this.addressForm.state = addressObj.state;
                this.addressForm.zip = addressObj.zip;
                this.informationForm.phone = '';
            }
        }, 
        validatePass(){
            if(this.password.length > 0 || this.ver_password.length > 0){
                if(this.password === this.ver_password){
                    this.step = 3;
                }
            }else{
                this.step = 3;
            }
        },
        generateRandomPassword() {
            const length = 16;
            const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";
            let retVal = "";
            for (let i = 0, n = charset.length; i < length; ++i) {
                retVal += charset.charAt(Math.floor(Math.random() * n));
            }
            return retVal + "aA1!"; // Ensure strong password rules are met
        },
        createPart(bypassValidation = false){
            let shouldBypass = bypassValidation === true;
            if (this.createMode === "emit" && !this.ageValidate18) {
                const requiredAge = this.minAdultAge > 0 ? this.minAdultAge : 18;
                this.showSnackBar(this.$t("waivers.signatory_must_be_adult", { age: requiredAge }), "error");
                return;
            }

            let data = {};
            if(!shouldBypass && !this.isSignatoryMode && this.$refs.emergencyForm && !this.$refs.emergencyForm.validate()) {
                if(this.isEmergencyContactisEmpty() && (this.emergencyForm.firstname || '').length > 0 && (this.emergencyForm.lastname || '').length > 0) {
                    this.showSnackBar(this.$t("registration.phone_cell_email_required"), "error");
                } else {
                    this.showSnackBar(this.$t("registration.finish_validate_step"), "error");
                }
                return;
            }
            data = {
                    userId: this.userId,
                    birthday: this.informationForm.birthdate,
                    firstname: this.informationForm.firstname,
                    gender: this.informationForm.gender,
                    lastname: this.informationForm.lastname,
                    address: this.addressForm.address,
                    city: this.addressForm.city,
                    country: this.addressForm.country,
                    state: this.addressForm.state,
                    zip: this.addressForm.zip,
            };
            if (!this.isSignatoryMode) {
                    data.ec_email = this.emergencyForm.email;
                    data.ec_firstname = this.emergencyForm.firstname;
                    data.ec_lastname = this.emergencyForm.lastname;
                    data.ec_phone = this.emergencyForm.phone;
                    data.ec_cell = this.emergencyForm.cell;
            } else {
                    data.ec_firstname = '';
                    data.ec_lastname = '';
                    data.ec_email = '';
                    data.ec_phone = '';
                    data.ec_cell = '';
            }
            let idUserCreated = 0;
            
            if(this.ageValidate18) {
                data.email = this.informationLogin.email;
                data.password = this.createMode === 'emit' ? this.generateRandomPassword() : this.informationLogin.password;
            }
            if(this.informationForm.phone.length > 0) data.phone = this.informationForm.phone;

            let type=""
            if(this.registrationType) {
                type = this.registrationType;
            } else if(this.$route.path == "/SpectatorsCreate")
                type = 'Spectator';
            else
                type = 'Participant';

            AuthService.registrationParticipant(data,type).then(response => {
                if(response.data.success == 1){
                    idUserCreated = response.data.message;
                    if(idUserCreated.original) {
                        if(idUserCreated.original.message == "duplicate_account") {
                            this.showSnackBar(this.$t("registration.duplicate_account"), "error");
                        }
                    } else {
                        RelationshipService.relationshipCreator({"relId": this.userId, "relType": '',"userRolesId": 1, "userId": idUserCreated}).then(resp =>{
                            if(resp.data.success == 1){
                                if (this.createMode === "emit") {
                                    this.$emit("created", {
                                        idUser: idUserCreated,
                                        email: this.informationLogin.email || this.prefillEmail || "",
                                        firstName: this.informationForm.firstname,
                                        lastName: this.informationForm.lastname,
                                        birthdate: this.informationForm.birthdate
                                    });
                                    this.clearForm();
                                    return;
                                }
                                let obj = {
                                    step: 1.2,
                                    idUser: idUserCreated
                                };
                                LocalStorageService.setItem("create_part", obj);
                                this.$emit("nextStep");
                                this.clearForm();
                            } else {
                                this.showSnackBar(this.$t("registration.failed_relation_participant"));
                            }
                        }).catch(() => {
                            this.showSnackBar(this.$t("registration.failed_relation_participant"));
                        });
                    }
                } else {
                    this.showSnackBar(this.$t("registration.failed_create_participant"));
                }
            }).catch(() => {
                this.showSnackBar(this.$t("registration.failed_create_participant"), "error");
            })
              
        },
        async goEmailStep() {
            if(!this.$refs.informationLogin.validate()) {
                this.showSnackBar(this.$t("registration.validate_step"), "error");
                return
            }
            let band = false;
            
            // Skip duplicate email check if the email belongs to the user we just matched
            if (!this.matchedUserEmail || this.informationLogin.email.toLowerCase() !== this.matchedUserEmail.toLowerCase()) {
                await AuthService.preventDuplicateEmail(this.informationLogin.email).then((resp) => {
                    if(resp.data.match) {
                        this.showSnackBar(this.$t(`registration.${resp.data.message}`), "error");
                        band = true;
                    }
                });
            }
            if(band) return;

            this.step = 3;
        },
        previusBtn() {
            this.$emit("previusStep");
        },
        clearForm() {
            this.step = 1;
            this.$refs.informationForm.reset();
            this.$refs.informationLogin.reset();
            this.$refs.addressForm.reset();
            this.$refs.emergencyForm.reset();
        },
        isValidPhone(number,index = 'phone') {

            if((number || '').length == 0) return true;

            let vm = this, response
            if((number || "").length > 0) {
                response = !!number.match(/^[0-9-]{10,12}$/);
            }
                        
            if((number || "").match(/^[0-9-]{3,12}$/)){
                vm.emergencyForm[index]=vm.emergencyForm[index].replaceAll("-", "")
                const lengthPhone = vm.emergencyForm[index].length
                            
                if(lengthPhone>=4 && lengthPhone<7){
                    vm.emergencyForm[index]=vm.emergencyForm[index].substring(0, 3)+"-"+vm.emergencyForm[index].substring(3)
                }

                if(lengthPhone>=7){
                    vm.emergencyForm[index]=vm.emergencyForm[index].replaceAll("-", "")
                    vm.emergencyForm[index]=vm.emergencyForm[index].substring(0, 3)+"-"+vm.emergencyForm[index].substring(3, 6) +"-"+vm.emergencyForm[index].substring(6)
                }
                
                if(lengthPhone<10){
                    return this.$t("registration.phone_invalid")
                }else if(lengthPhone>10){
                    return this.$t("registration.phone_invalid")
                }else{
                    vm.emergencyForm[index]=vm.emergencyForm[index].replaceAll("-", "")
                    vm.emergencyForm[index]=vm.emergencyForm[index].substring(0, 3) +"-"+vm.emergencyForm[index].substring(3, 6) +"-"+vm.emergencyForm[index].substring(6, 10)
                } 
            }
            
            if(!response) {
                return this.$t("registration.phone_invalid")
            }

            return true;
        },
        isValidEmail(email) {

            if((email || '').length == 0) return true;

            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return email && !!pattern.test(email);
        },
        isEmergencyContactisEmpty() {
            return (this.emergencyForm.phone || '').length == 0 && (this.emergencyForm.cell || '').length == 0 && (this.emergencyForm.email || '').length == 0;
        }
    },
    watch: { 
        prefillEmail: {
            immediate: true,
            handler(value) {
                const normalizedEmail = (value || "").toString().trim();
                if (!normalizedEmail) {
                    return;
                }

                this.informationLogin.email = normalizedEmail;
                this.informationLogin.confirmEmail = normalizedEmail;
            }
        },
        addressDataComponentUpdateVersion()
        {
            const updateId = this.addressDataComponentUpdateId;
            if(!updateId)
            {
                this.msg_snackbar = 'addressDataComponentUpdateId';
                this.color_snackbar = 'error';
                this.snackbar = true;
                return;
            }
            
            if(this.addressDataComponents.length == 0)
            {
                this.msg_snackbar = 'addressDataComponents';
                this.color_snackbar = 'error';
                this.snackbar = true;
                return;
            }
            
            const index = this.addressDataComponents.findIndex(obj => obj.updateId == updateId);
            const addressComponent = this.addressDataComponents[index];

            this.addressForm.address = addressComponent.address;
            this.addressForm.country = addressComponent.country;
            this.addressForm.city = addressComponent.city;
            this.addressForm.state = addressComponent.state;
            this.addressForm.zip = addressComponent.zip;

        }, 
        'addressForm.address': {
            handler(){
                this.isValidateAddress = true;
            },
            deep: true
        },
        'addressForm.country': {
            handler(val){
                if(val) {
                    this.getStatesByCountry();
                } 
            },
            deep: true
        },
        menu (val) {
            val && setTimeout(() => (this.activePicker = 'YEAR'))
        },
        spaceCleaner(val, oldVal){
            const fields = val;
            const fieldsOld = oldVal;
            this.$nextTick(() => {
                if(fields[0] != fieldsOld[0]){
                    this.informationLogin.email = this.$inputFormatter(fields[0], 'spaceCleaner');
                }
                if(fields[1] != fieldsOld[1]){
                    this.informationLogin.confirmEmail = this.$inputFormatter(fields[1], 'spaceCleaner');
                }
                if(fields[2] != fieldsOld[2]){
                    this.informationLogin.password = this.$inputFormatter(fields[2], 'spaceCleaner');
                }
                if(fields[3] != fieldsOld[3]){
                    this.informationLogin.confirmPassword = this.$inputFormatter(fields[3], 'spaceCleaner');
                }
            });
        },
        'emergencyForm.phone': {
            handler(newValue, oldValue) {
                if(!this.isNotAvailableValidate) {
                    if(newValue != oldValue) {
                        this.$refs.ecCell.validate();
                        this.$refs.ecEmail.validate();
                    }
                }
            },
            deep: true
        },
        'emergencyForm.cell': {
            handler(newValue, oldValue) {
                if(!this.isNotAvailableValidate) {
                    if(newValue != oldValue) {
                        this.$refs.ecPhone.validate();
                        this.$refs.ecEmail.validate();
                    }
                }
            },
            deep: true
        },
        'emergencyForm.email': {
            handler(newValue, oldValue) {
                if(!this.isNotAvailableValidate) {
                    if(newValue != oldValue) {
                        this.$refs.ecCell.validate();
                        this.$refs.ecPhone.validate();
                    }
                }
            },
            deep: true
        },
        phoneNumber(val) {
            this.$nextTick(() => {
                this.informationForm.phone = this.$inputFormatter(val, 'spaceCleaner');
                this.informationForm.phone = this.$inputFormatter(val, 'phoneNumber');
            });
        },
        emergencyContactPhone(val) {
            this.$nextTick(() => {
                this.emergencyForm.phone = this.$inputFormatter(val, 'spaceCleaner');
                this.emergencyForm.phone = this.$inputFormatter(val, 'phoneNumber');
            });
        },
        emergencyContactCell(val) {
            this.$nextTick(() => {
                this.emergencyForm.cell = this.$inputFormatter(val, 'spaceCleaner');
                this.emergencyForm.cell = this.$inputFormatter(val, 'phoneNumber');
            });
        }
    }
}
</script>

<style>
.btn_back {
    color: #fff !important;
}
</style>